import { render, staticRenderFns } from "./LabelBase.vue?vue&type=template&id=2ff72911&scoped=true"
import script from "./LabelBase.vue?vue&type=script&lang=js"
export * from "./LabelBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff72911",
  null
  
)

export default component.exports